import { useState } from 'react';
import { Message } from 'react-frontier';
import { useUser } from '../HooksPublic';
import API from '../APIPublic';
import styles from '../style/user_account.module.scss';
import { UserCreditsBalance, UserLevelsData } from '../ClassesPublic';
import { WalletCard } from './WalletCard';

var UserAccountWallet = ({
   levelsData,
   levelsError,
   creditsBalance
}: {
   levelsData: UserLevelsData | null;
   levelsError: string | null;
   creditsBalance: UserCreditsBalance | null;
}) => {
   var { user, token } = useUser();
   var [walletError, setWalletError] = useState<string>(null);
   var [googleLoading, setGoogleLoading] = useState<boolean>(false);
   var [appleLoading, setAppleLoading] = useState<boolean>(false);

   return <div className={styles.flexColumn}>
         {levelsError && (
            <div className={styles.padding20}>
               <Message type="error" text={levelsError} />
            </div>
         )}
         {walletError && (
            <div className={styles.padding20}>
               <Message type="error" text={walletError} />
            </div>
         )}
         {user && (() => {
            var pts = creditsBalance?.available ?? 0;
            var sortedLevels = levelsData?.levels ? [...levelsData.levels].sort((a, b) => a.points - b.points) : [];

            if (sortedLevels.length === 0) {
               return <div className={styles.padding20} style={{ textAlign: 'center' }}>
                     <Message type="info" text="Tu tarjeta digital no está disponible en este momento." />
                  </div>
            }

            var activeTierName = sortedLevels[0]?.level_name || 'Sin nivel';
            var activeTierLevel = 1;
            var activeLevelId = sortedLevels[0]?.level_id;
            for (var i = 0; i < sortedLevels.length; i++) {
               if (pts >= sortedLevels[i].points) {
                  activeTierName = sortedLevels[i].level_name;
                  activeTierLevel = i + 1;
                  activeLevelId = sortedLevels[i].level_id;
               } else {
                  break;
               }
            }
            var accountCode = `COCOAN-${(user as any).alias || user.user_id}`;
            return <WalletCard
                  level_id={activeLevelId}
                  tier={activeTierName}
                  tierLevel={activeTierLevel}
                  points={pts}
                  userName={`${user.first_name} ${user.last_name}`}
                  accountCode={accountCode}
                  loadingGoogle={googleLoading}
                  loadingApple={appleLoading}
                  expiryDate={creditsBalance?.expires}
                  onDownloadGooglePass={() => {
                     if (!token || googleLoading) return;
                     setWalletError(null);
                     setGoogleLoading(true);
                     API.getGooglePass(token.access).then(res => {
                        setGoogleLoading(false);
                        if (res.error || !res.data?.saveUrl) {
                           setWalletError(res.message || 'Error al generar el pase de Google Wallet');
                           return;
                        }
                        window.location.href = res.data.saveUrl;
                     }).catch(e => {
                        console.error(e);
                        setGoogleLoading(false);
                        setWalletError('Error al descargar el pase de Google Wallet');
                     });
                  }}
                  onDownloadApplePass={() => {
                     if (!token || appleLoading) return;
                     setWalletError(null);
                     setAppleLoading(true);
                     API.getApplePass(token.access).then(res => {
                        setAppleLoading(false);
                        if (res.error || !res.data?.buffer) {
                           setWalletError(res.message || 'Error al descargar el pase');
                           return;
                        }
                        const base64Buffer = res.data.buffer;
                        const binaryString = window.atob(base64Buffer);
                        const len = binaryString.length;
                        const bytes = new Uint8Array(len);
                        for (let i = 0; i < len; i++) {
                           bytes[i] = binaryString.charCodeAt(i);
                        }
                        const blob = new Blob([bytes.buffer], { type: res.data.mimeType });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'cocoan.pkpass');
                        document.body.appendChild(link);
                        link.click();
                        link.parentNode?.removeChild(link);
                     }).catch(e => {
                        console.error(e);
                        setAppleLoading(false);
                        setWalletError('Error al descargar el pase de Apple Wallet');
                     });
                  }}
               />
         })()}
   </div>
};

export default UserAccountWallet;
